import { render, staticRenderFns } from "./TextTop.vue?vue&type=template&id=e88571d8&scoped=true&"
import script from "./TextTop.vue?vue&type=script&lang=js&"
export * from "./TextTop.vue?vue&type=script&lang=js&"
import style0 from "./TextTop.vue?vue&type=style&index=0&id=e88571d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88571d8",
  null
  
)

export default component.exports